module.exports = __webpack_public_path__ + "static/media/blastoff-en.76ce2277.png";